const NatoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111970)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#0052B4"
      />
      <path
        d="M28.5828 21.3964C28.6564 20.9419 28.6952 20.4759 28.6952 20.0011C28.6952 20.4759 28.6564 20.9419 28.5828 21.3964L32.1735 20.0011L28.5828 18.6058L26.6105 17.8395L23.4062 16.5944L22.1612 13.3901C24.2607 14.0783 25.9222 15.7398 26.6104 17.8394L28.5827 18.6057C27.9867 14.9264 25.0741 12.0137 21.3948 11.4178L19.9996 7.82715L18.6043 11.4179C14.9249 12.0139 12.0124 14.9264 11.4164 18.6058L7.82568 20.0011L11.4165 21.3964C12.0125 25.0757 14.925 27.9882 18.6044 28.5843L19.9996 32.175L21.3949 28.5843C25.0742 27.9882 27.9868 25.0757 28.5828 21.3964ZM22.0627 17.938L19.9996 20.0011H27.3719L22.0626 22.0642L19.9996 20.0011V27.3734L17.9365 22.0641L19.9996 20.0011H12.6273L17.9365 17.938L19.9996 20.0011V12.6288L22.0627 17.938ZM17.8379 13.3902L16.5928 16.5945L13.3887 17.8396C14.0769 15.7398 15.7383 14.0785 17.8379 13.3902ZM13.3887 22.1627L16.5928 23.4078L17.8379 26.6119C15.7383 25.9236 14.077 24.2623 13.3887 22.1627ZM22.1612 26.6119L23.4063 23.4078L26.6104 22.1627C25.9222 24.2623 24.2608 25.9236 22.1612 26.6119Z"
        fill="#F0F0F0"
      />
      <path d="M27.3723 20H20L22.0631 22.0631L27.3723 20Z" fill="#0052B4" />
      <path d="M12.6279 19.9996H20.0002L17.9371 17.9365L12.6279 19.9996Z" fill="#0052B4" />
      <path d="M20.0001 27.3723V20L17.937 22.0631L20.0001 27.3723Z" fill="#0052B4" />
      <path d="M20 20.0002L22.0631 17.9371L20 12.6279V20.0002Z" fill="#0052B4" />
      <path d="M19.1299 2.6084H20.869V6.08668H19.1299V2.6084Z" fill="#F0F0F0" />
      <path d="M2.6084 19.1299H6.08668V20.869H2.6084V19.1299Z" fill="#F0F0F0" />
      <path d="M19.1299 33.9131H20.869V37.3914H19.1299V33.9131Z" fill="#F0F0F0" />
      <path d="M33.9126 19.1299H37.3909V20.869H33.9126V19.1299Z" fill="#F0F0F0" />
    </g>
    <defs>
      <clipPath id="clip0_4152_111970">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NatoSvg;
